(() => {
  'use strict';
  if (window.avoraOfferAlignmentLoaded) return;
  window.avoraOfferAlignmentLoaded = true;
  const branchOf = (node, parent) => {
    while (node && node.parentElement !== parent) node = node.parentElement;
    return node;
  };
  const compareTextCache = new Map();
  const syncSingleCompare = (root, quantity, prices) => {
    const amount = Number(root.dataset.avoraSingleComparePrice);
    const regularLabel = root.dataset.avoraRegularPriceLabel;
    const eligible = Number.isFinite(amount) && amount > Number(root.dataset.avoraSinglePrice) && root.dataset.currency === 'EUR' && regularLabel && quantity === 1;
    let compare = prices.querySelector('[data-avora-single-compare]');
    let spoken = prices.querySelector('[data-avora-single-compare-label]');
    if (!eligible || prices.querySelector('.Avada-Offer__PriceDefault:not([data-avora-single-compare])')) {
      compare?.remove();
      spoken?.remove();
      return;
    }
    const locale = document.documentElement.lang || 'fi-FI';
    const cacheKey = `${locale}:${amount}`;
    if (!compareTextCache.has(cacheKey)) {
      try { compareTextCache.set(cacheKey, new Intl.NumberFormat(locale, {style:'currency', currency:'EUR', currencyDisplay:'symbol'}).format(amount / 100)); }
      catch (_) { return; }
    }
    const text = compareTextCache.get(cacheKey);
    const visible = prices.querySelector(':scope > .aov-a11y-price__visible') || prices;
    if (!compare) {
      compare = document.createElement('div');
      compare.className = 'Avada-Offer__PriceDefault';
      compare.dataset.avoraSingleCompare = '';
      compare.setAttribute('aria-hidden', 'true');
      const value = document.createElement('s');
      value.className = 'AOV-Offer__BasePrice';
      compare.append(value);
    }
    if (compare.firstElementChild.textContent !== text) compare.firstElementChild.textContent = text;
    if (compare.parentElement !== visible) visible.append(compare);
    if (!spoken) {
      spoken = document.createElement('span');
      spoken.className = 'visually-hidden';
      spoken.dataset.avoraSingleCompareLabel = '';
    }
    const spokenText = `${regularLabel} ${text}. `;
    if (spoken.textContent !== spokenText) spoken.textContent = spokenText;
    if (spoken.parentElement !== prices) prices.prepend(spoken);
  };
  const syncOfferCopy = (root, quantity, label, labelBranch, price) => {
    const heading = quantity === 1 ? root.dataset.avoraOnePairLabel : quantity === 2 ? root.dataset.avoraTwoPairsLabel : '';
    const headingNode = label.querySelector('span') || label;
    if (heading && headingNode.textContent !== heading) headingNode.textContent = heading;
    const shippingText = root.dataset.avoraBundleShippingLabel;
    const threshold = Number(root.dataset.avoraFreeShippingThreshold);
    const displayedAmount = Math.round(Number(price.textContent.replace(/[^\d.,]/g, '').replace(',', '.')) * 100);
    const eligible = quantity === 2 && shippingText && threshold > 0 && displayedAmount >= threshold;
    let shipping = labelBranch.querySelector('[data-avora-bundle-shipping]');
    if (!eligible) {
      shipping?.remove();
      return;
    }
    if (!shipping) {
      shipping = document.createElement('span');
      shipping.dataset.avoraBundleShipping = '';
      labelBranch.append(shipping);
    }
    if (shipping.textContent !== shippingText) shipping.textContent = shippingText;
  };
  const align = (root) => {
    root.querySelectorAll('.Avada-Volume__Item').forEach(item => {
      const label = item.querySelector('.Avada-Volume__Info--TriggerQty');
      const price = item.querySelector('.AOV-Offer__DiscountPrice');
      if (!label || !price || label.contains(price)) return;
      let row = label.parentElement;
      while (row && row !== item && !row.contains(price)) row = row.parentElement;
      if (!row || row === item || row.querySelector('.Avada-VariantSelection__Trigger')) return;
      const labelBranch = branchOf(label, row);
      const priceBranch = branchOf(price, row);
      if (!labelBranch || !priceBranch || labelBranch === priceBranch) return;
      const other = [...row.children].filter(child => child !== labelBranch && child !== priceBranch);
      if (other.some(child => !child.matches('input,svg,.Avada-VolumeBoxBadge') && !child.querySelector('input[type="radio"]'))) return;
      if (!row.hasAttribute('data-avora-offer-row')) row.dataset.avoraOfferRow = '';
      if (!labelBranch.hasAttribute('data-avora-offer-label')) labelBranch.dataset.avoraOfferLabel = '';
      if (!priceBranch.hasAttribute('data-avora-offer-prices')) priceBranch.dataset.avoraOfferPrices = '';
      const quantity = Number(label.textContent.trim().match(/^(?:Osta|Buy)\s+(\d+)\b/i)?.[1]);
      syncOfferCopy(root, quantity, label, labelBranch, price);
      syncSingleCompare(root, quantity, priceBranch);
    });
  };
  let frame = 0;
  const roots = new Map();
  const pending = new Set();
  const options = {childList:true,subtree:true,characterData:true};
  const schedule = (root) => {
    pending.add(root);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      pending.forEach(node => { if (node.isConnected) align(node); });
      pending.clear();
    });
  };
  const setup = () => {
    document.querySelectorAll('product-info').forEach(root => {
      if (roots.has(root)) return;
      const observer = new MutationObserver(records => {
        if (records.some(record => {
          const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          return target?.closest('.Avada-Volume__Item') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.Avada-Volume__Item') || node.querySelector('.Avada-Volume__Item')));
        })) schedule(root);
      });
      roots.set(root, observer);
      observer.observe(root, options);
      schedule(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true}); else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', event => {
    roots.forEach((observer, root) => {
      if (event.target.contains(root)) { observer.disconnect(); roots.delete(root); pending.delete(root); }
    });
  });
  window.addEventListener('pagehide', () => {
    roots.forEach(observer => observer.disconnect());
    cancelAnimationFrame(frame);
    frame = 0;
    pending.clear();
  });
  window.addEventListener('pageshow', () => {
    roots.forEach((observer, root) => {
      if (root.isConnected) { observer.observe(root, options); schedule(root); }
      else roots.delete(root);
    });
    setup();
  });
})();
